<template>
<div class="lds-dual-ring">
  <div :style="{ border: `3px solid ${color}`, borderColor: `${color} transparent ${color} transparent`, width: `${width}`, height: `${height}` }"></div>
</div>
</template>

<script>
export default {
  name: 'LoaderComponent',
  props: {
    color: {
      type: String,
      default: 'white',
    },
    width: {
      type: String,
      default: '30px',
    },
    height: {
      type: String,
      default: '30px',
    },
  }
}
</script>

<style scoped>

.lds-dual-ring {
  display: inline-block;
  width: fit-content;
  height: fit-content;
}
.lds-dual-ring div {
  box-sizing: border-box;
  display: block;
  /* width: 30px; */
  /* height: 30px; */
  border: 3px solid;
  border-radius: 50%;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>